import {get, post, put} from "services/BaseClient/Client"
import endPoints from "apps/Account/Pages/Institutional/EndPoints"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";





export const getIETTSInfoes= async (data: any): Promise<DataResponse<any>> => {
    const url = `${endPoints.getIETTSInfo}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url,data, config);
  };

  export const getCorporateContract= async (): Promise<DataResponse<any>> => {
    const url = `${endPoints.getCorporate}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url,config);
  };

  export const  getTTBSInfoes= async (data: any): Promise<DataResponse<any>> => {
    const url = `${endPoints.getTTBSInfo}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data,config);
  };
  
  export const  createStore= async (data: any): Promise<DataResponse<any>> => {
    const url = `${endPoints.createStore}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data,config);
  };
  export const  editStore= async (data: any): Promise<DataResponse<any>> => {
    const url = `${endPoints.updateStore}`;
    const config = headers.content_type.application_json;
    return put<DataResponse<any>>(url, data,config);
  };